import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/how-it-works-screen';

function HowItWorks() {
  return <Screen />;
}
export default HowItWorks;
